import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import useModuleStore from '../../stores/moduleStore';

/**
 * ModuleGuard — Route-Schutz fuer deaktivierte Module
 *
 * Wenn Modul deaktiviert → Redirect zum Dashboard + Info-Anzeige.
 * Fail-open: Wenn Module noch nicht geladen → Inhalt zeigen.
 */
export default function ModuleGuard({ module, children }) {
  const isEnabled = useModuleStore((s) => s.isEnabled);
  const loaded = useModuleStore((s) => s.loaded);
  const navigate = useNavigate();

  const enabled = isEnabled(module);

  useEffect(() => {
    if (loaded && !enabled) {
      // Modul deaktiviert — zurueck zum Dashboard
      navigate('/', { replace: true });
    }
  }, [loaded, enabled, navigate]);

  // Noch nicht geladen → fail-open (Inhalt zeigen)
  if (!loaded) return children;

  // Modul deaktiviert → Blockade-Screen (kurz sichtbar vor Redirect)
  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <div className="w-16 h-16 bg-gray-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4">
          <Lock size={28} className="text-gray-400 dark:text-slate-500" />
        </div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100 mb-2">
          Modul nicht verfügbar
        </h2>
        <p className="text-sm text-gray-500 dark:text-slate-400 max-w-sm">
          Dieses Modul ist für deine Organisation nicht aktiviert.
          Kontaktiere einen Administrator für die Freischaltung.
        </p>
      </div>
    );
  }

  return children;
}
